const GET_SAS_SUCCESS = 'GET_SAS_SUCCESS'
const GET_SAS_FAIL = 'GET_SAS_FAIL'

export const defaultBlobState = {
  sas: null
}

export default (state = defaultBlobState, action) => {
  switch (action.type) {
    case GET_SAS_SUCCESS:
      return {
        ...state,
        sas: action.payload.data
      }
    case GET_SAS_FAIL:
      return {
        ...state,
        sas: null
      }
    default:
      return state
  }
}
